'use strict';

/**
 * @constant clickPath {Array} - An array of previous steps.
 */
const clickPath = [];

/**
 * @public stepForward
 * @param {string} index - The index of the page we just left
 * @returns {string} index;
 */
function stepForward(index) {
    clickPath.push(index);
    return index;
}

/**
 * @public stepBackward
 * @returns {string} index;
 */
function stepBackward() {
    clickPath.pop();
    return clickPath[clickPath.length - 1];
}

/**
 * @public keyboardNavigation
 * @param {event} event - The event
 *
 * @description
 * Will allow the user to use the keyboard to navigate through the BScan
 */
function keyboardNavigation(event) {
    if (!this.currentStep) {
        this.currentStep = document.querySelector(`${this.selectors.step}.${this.CONST.classes.active}`);
    }

    this.currentStepInput = this.currentStep.querySelector(this.CONST.selectors.form.input);

    // Will allow the user to go to the next page by hitting enter, if there are no questions
    if (
        event.key === 'Enter' &&
        !this.currentStepInput &&
        (this.currentStep.classList.contains(this.classes.stepStart) || this.currentStep.classList.contains(this.classes.stepQuestion))
    ) {
        // Doing `form.submit()` will somehow result in `on submit event` not being listened to.
        this.currentStep.querySelector(this.selectors.button.next).click();
    }
}

export { stepForward, stepBackward, keyboardNavigation };
